export default {
  getHead: () => {
    return [{name: '사업장명'}, {name: '부서'}, {name: '작성소속'}, {name: '작성자 '}, {name: '작성일'}, {name: '재해형태'}, {name: '위험성'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).inputA_1
      case 1: return func.getContent(value).inputA_2
      case 2: return func.getContent(value).inputA_3
      case 3: return func.getContent(value).stdInfo.writer_name
      case 4: return func.getCreatedDate(value.created_at) // 작성일
      case 5: return func.getContent(value).inputB_2
      case 6: return func.getContent(value).inputD_2
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.inputA_5) {
      nav.dateTarget = 'content$body.inputA_5'
      nav.dateBegin = 'nav.value.inputA_5.sDate'
      nav.dateEnd = 'nav.value.inputA_5.eDate'
    }
    return { inputA_5: nav.value.inputA_5, inputB_2: nav.value.inputB_2}
  },
  getSearchKeyword: (nav) => {
    return ['content$body.inputB_2*[:nav.page.p63.inputB_2]']
  },
}
